import { AvatarVariant as AvatarVariantApi } from '@wix/ambassador-asa-assistant-properties-v1-assistant-properties/types';
import { AvatarVariant, isValidAssistantProperties } from './AssistantProperties';
const avatarVariantApiToAvatarVariantMap = {
  [AvatarVariantApi.UNSELECTED]: AvatarVariant.UNSELECTED,
  [AvatarVariantApi.MARBLE]: AvatarVariant.MARBLE,
  [AvatarVariantApi.BEAM]: AvatarVariant.BEAM,
  [AvatarVariantApi.PIXEL]: AvatarVariant.PIXEL,
  [AvatarVariantApi.SUNSET]: AvatarVariant.SUNSET,
  [AvatarVariantApi.RING]: AvatarVariant.RING
};
const avatarVariantToAvatarVariantApiMap = {
  [AvatarVariant.UNSELECTED]: AvatarVariantApi.UNSELECTED,
  [AvatarVariant.MARBLE]: AvatarVariantApi.MARBLE,
  [AvatarVariant.BEAM]: AvatarVariantApi.BEAM,
  [AvatarVariant.PIXEL]: AvatarVariantApi.PIXEL,
  [AvatarVariant.SUNSET]: AvatarVariantApi.SUNSET,
  [AvatarVariant.RING]: AvatarVariantApi.RING
};
export const avatarVariantApiToAvatarVariant = avatarVariant => {
  if (!avatarVariant) {
    throw new Error('empty avatar variant api');
  }
  const mappedAvatarVariant = avatarVariantApiToAvatarVariantMap[avatarVariant];
  if (!mappedAvatarVariant) {
    throw new Error('Unknown avatar variant api');
  }
  return mappedAvatarVariant;
};
export const avatarVariantToAvatarVariantApi = avatarVariant => {
  const mappedAvatarVariant = avatarVariantToAvatarVariantApiMap[avatarVariant];
  if (!mappedAvatarVariant) {
    throw new Error('Unknown avatar variant');
  }
  return mappedAvatarVariant;
};
export const assistantPropertiesApiToAssistantProperties = assistantProperties => {
  if (!assistantProperties) {
    throw new Error('empty assistant properties');
  }
  const {
    id,
    revision,
    name,
    imageUrl,
    avatarVariant,
    persona: {
      personality,
      pronouns,
      traits
    } = {}
  } = assistantProperties;
  const properties = {
    id,
    revision,
    personality,
    pronouns,
    name,
    imageUrl,
    avatarVariant: avatarVariantApiToAvatarVariant(avatarVariant),
    traits: traits
  };
  if (isValidAssistantProperties(properties)) {
    return properties;
  }
  throw new Error('Invalid AssistantProperties data');
};
//# sourceMappingURL=converters.js.map